module.exports = __webpack_public_path__ + "static/media/16UNODC14.82d29d0b.jpg";